import React from 'react';
import ImageSlider from './ImageSlider';

const Gallery = () => {
    return (
        <div className='pt-24 md:pt-48 pb-16'>
            <a id="gallery"/>
            <ImageSlider />
        </div>
    );
};

export default Gallery;
